export class FiltrosRepContabilidad{
   
    Usuario : string ='';
    Estado: string = '';
    idEmpresa: string = '4';
    Tipo: string = 'factura_generada';
 
 }